
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      

      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsNavbarVisible(true);
      } else {
        setIsNavbarVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);


  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }


    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <>
      <nav className={`navbar ${isNavbarVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src='/logo-villa.png' alt='logo' />
        </Link>
      </div>
        

        <ul className="navbar-nav desktop-nav">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/About">About Us</Link></li>
          <li><Link to="/photos">Photos</Link></li>
          <li><Link to="/Services">Services</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      
      <div className="navbar-menu-toggle" onClick={toggleMenu}>
        <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
      </div>
      </nav>
      
      {createPortal(
        <ul className={`navbar-nav mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">
            ×
          </button>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/About" onClick={closeMenu}>About Us</Link></li>
        <li><Link to="/photos" onClick={closeMenu}>Photos</Link></li>
        <li><Link to="/Services" onClick={closeMenu}>Services</Link></li>
        <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
        </ul>,
        document.body
      )}
    </>
  );
}

export default Navbar;
